<template>
    <!-- Race Stepper-->
    <!-- <div class="absolute flex -top-11 text-sm font-semibold">Close Meeting</div> -->
    <div v-if="$page.props.features.new_meetings_accordion == true" class="w-full h-20 md:h-28 hidden md:flex justify-between">
        <div class="font-bold text-racing-stars-yellow uppercase text-base md:text-2xl my-auto">
            {{ meeting.name }}
        </div>
        <div @click="$emit('closeMeeting')" class="font-bold text-racing-stars-yellow uppercase border p-2 rounded-md border-racing-stars-yellow text-xs md:text-sm my-auto cursor cursor-pointer hover:bg-racing-stars-yellow hover:text-black">
            close
        </div>
    </div>
    <div
        ref="meetingRef"
        :class="[
            !isMobile
                ? 'gap-1 grid sm:auto-cols-auto md:grid-flow-col mb-2 md:grid-cols-' +
                  races.length
                : 'gap-1 grid auto-cols-auto mb-2 overflow-visible grid-cols-4 w-full',
        ]"
    >
        <div
            v-for="race in races"
            class="p-0 h-10 rounded text-center items-center justify-center text-xs md:text-sm flex cursor-pointer font-semibold"
            @click="getItems(race.id)"
            :class="[
                selectedRaceId === race.id ||
                (!selectedRaceId && !race.starts_at)
                    ? 'bg-racing-stars-yellow text-gray-900'
                    : 'bg-[#272727] text-white',
            ]"
        >
            <span v-if="!race.starts_at">
                <ClipboardCheckIcon class="w-7" />
            </span>

            <span v-else>
                    {{ moment(race.starts_at).format("k:mm") }}
            </span>
        </div>
    </div>

    <div v-if="processing" class="flex justify-center md:mt-0">
        <span
            class="text-gray-900 bg-racing-stars-yellow font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 inline-flex items-center"
        >
            <svg
                role="status"
                class="inline mr-3 w-4 h-4 text-white animate-spin"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#000001"
                />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                />
            </svg>
            Loading...
        </span>
    </div>

    <div
        class="p-4 text-center rounded bg-racing-stars-yellow text-gray-900 mb-4 md:mt-0"
        v-else-if="isEmpty(raceResults) && meeting.finished"
    >
        Awaiting race results...
    </div>

    <div v-else>
        <div
            class="p-4 text-center text-xs sm:text-base rounded bg-racing-stars-yellow text-gray-900 mb-4 mt-4 sm:mt-0"
            v-if="message"
        >
            {{ message }}
        </div>

        <div
            class="p-4 text-center text-xs sm:text-base rounded bg-red-500 text-white mb-4 mt-4 sm:mt-0"
            v-if="error"
        >
            {{ error }}
        </div>

        <!-- Race Details -->
        <race-details
            :meeting="meeting"
            :race="selectedRace"
            v-if="selectedRaceId"
        />

        <!-- Selections Screen -->
         <selections
            v-if="!selectedRaceId && !isEmpty(selections)"
            :meeting="meeting"
            :selections="!isEmpty(selections) ? selections : []"
            :bets="bets"
            :user="$page.props.user"
            @changeSelection="updateRace"
        />

        <!-- Confirmation Screen -->
        <confirm
            v-else-if="!selectedRaceId && isEmpty(raceResults)"
            :meeting="meeting"
            @changeSelection="updateRace"
            @hasBet="getSelections"
        />

        <!-- Results -->
        <results v-if="selectedRaceId && !isEmpty(raceResults)" :results="raceResults" />

        <!-- Race Runners -->
        <runners
            v-if="selectedRaceId && isEmpty(raceResults)"
            :runners="raceRunners"
            :meeting="meeting"
            :selections="selections"
            :bets="bets"
            :showPercentage="showPercentage"
            @updateSelected="updateSelected"
            @updateRunner="updateRunner"
            @scrollToElement="scroll"
        />
        <!-- <div
            class="text-center sm:text-left"
            v-if="!selectedRaceId && isEmpty(selections)"
        >
            You have not picked any horses for this meeting.
        </div> -->

    </div>
</template>

<script>
import { watch, ref, reactive, onMounted, computed } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import { ClipboardCheckIcon } from "@heroicons/vue/outline";
import RaceDetails from "@/Global/Play/Partials/RaceDetails";
import Selections from "@/Global/Play/Partials/Selections";
import Confirm from "@/Global/Play/Partials/Confirm";
import Results from "@/Global/Play/Partials/Results";
import Runners from "@/Global/Play/Partials/Runners";
import Popper from "vue3-popper";

export default {
    components: {
        ClipboardCheckIcon,
        Popper,
    },

    props: {
        user: {
            type: Object,
            default: {},
        },
        meeting: {
            type: Object,
            default: {},
        },
        races: {
            type: Object,
            default: {},
        },
        bets: {
            type: Array,
            default: [],
        },
        showPercentage: {
            type: Object,
            default: {},
        },
    },

    created() {
        window.addEventListener("beforeunload", this.resetSessionStorage);
    },

    setup(props, { emit }) {
        const store = useStore();

        const selectedRaceId = ref(null);

        const selectedRace = ref({});

        const raceRunners = ref({});

        const processing = ref(true);

        const raceResults = ref({});

        const selections = ref({});

        const message = ref(null);

        const error = ref();

        const meetingRef = ref(props.meeting.id);

        const windowWidth = ref(window.innerWidth);

        const log = (logger) => {
            return console.log(logger);
        };

        const getBet = () => {
            let meetingBet = null;

            props.meeting.bets.forEach((bet) => {
                props.bets.forEach((userBet) => {
                    if (userBet.id === bet.id) {
                        meetingBet = userBet;
                    }
                });
            });

            return meetingBet;
        };

        const getSelections = () => {
            axios
                .get(route("api.selections.index"), {
                    params: {
                        meeting_id: props.meeting.id,
                    },
                })
                .then((response) => {
                    selections.value = response.data;
                });
        };

        const getRunners = (raceId) => {
            console.log(raceId);
            console.log("hello");
            if (raceId) {
                axios
                    .get(route("api.runners.index"), {
                        params: {
                            race_id: raceId,
                        },
                    })
                    .then((response) => {
                        raceRunners.value = response.data;
                        selectedRaceId.value = raceId;

                        Object.keys(props.races).forEach((key) => {
                            if (
                                props.races[key] &&
                                props.races[key].id === raceId
                            ) {
                                selectedRace.value = props.races[key];
                            }
                        });
                    });
            } else {
                getSelections();
                selectedRaceId.value = null;
                selectedRace.value = {};
            }
        };

        const getResults = (raceId) => {
            if (raceId) {
                processing.value = true;
                axios
                    .get(route("api.results.index"), {
                        params: {
                            race_id: raceId,
                        },
                    })
                    .then((response) => {
                        selectedRaceId.value = raceId;
                        raceResults.value = response.data;

                        Object.keys(props.races).forEach((key) => {
                            if (
                                props.races[key] &&
                                props.races[key].id === raceId
                            ) {
                                selectedRace.value = props.races[key];
                            }
                        });

                        processing.value = false;
                    });
            } else {
                getSelections();
                selectedRaceId.value = null;
                selectedRace.value = {};
            }
        };

        const getItems = (raceId) => {
            if (props.meeting.finished_at == null) {
                getRunners(raceId);
            }

            getResults(raceId);
        };

        const updateRunner = (runner) => {
            let bet = getBet();

            axios
                .patch(route("api.bets.update", { bet: bet }), {
                    runner: runner,
                })
                .then((response) => {
                    message.value = "Runner Changed";

                    updateSelected(response.data);

                    getSelections();

                    setTimeout(() => {
                        message.value = null;
                    }, 3000);
                })
                .catch((errors) => {
                    if (errors.response.data.invalid != undefined) {
                        error.value = errors.response.data.invalid;
                    }
                });
        };

        const updateSelected = (runner) => {
            store.commit("updateSelectedRunners", runner);

            Object.keys(props.races).forEach((key) => {
                if (props.races[key].id == runner.race.id) {
                    let raceKey = parseInt(key) + 1;

                    getRunners(props.races[raceKey].id);
                }
            });
        };

        const updateRace = (selection) => {
            Object.keys(props.races).forEach((key) => {
                if (props.races[key].id == selection.race.id) {
                    getRunners(props.races[key].id);
                }
            });
        };

        const scroll = (refName) => {
            if (refName == props.meeting.id) {
                var element = meetingRef.value;
                var top = element.offsetTop;

                element.scrollIntoView();
            }
        };

        const isMobile = computed(() => {
            return windowWidth.value < 768;
        });

        const setWindowWidth = () => {
            windowWidth.value = window.innerWidth;
        };

        onMounted(() => {
            getSelections();
            setWindowWidth();
            window.addEventListener("resize", setWindowWidth);

            setTimeout(() => {
                if (Object.keys(selections.value).length > 0) {
                    selectedRaceId.value = null;
                }
            }, 500);

            Echo.private("notifications." + props.user.id).listen(
                "BetPlaced",
                (e) => {
                    getSelections();
                    getRunners();
                    getResults();
                }
            );
        });

        watch(
            () => props.races,
            (currentValue, oldValue) => {
                if (!Object.keys(raceRunners.value).length) {
                    if (props.meeting.finished_at == null) {
                        getRunners(props.races[0].id);
                    }

                    getResults(props.races[0].id);
                }
            }
        );

        return {
            moment,
            getRunners,
            selectedRaceId,
            raceResults,
            raceRunners,
            selectedRace,
            updateSelected,
            updateRace,
            getItems,
            selections,
            updateRunner,
            message,
            error,
            getSelections,
            processing,
            scroll,
            meetingRef,
            log,
            isMobile,
        };
    },
};
</script>
